import React from 'react';
import PropTypes from 'prop-types';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    backgroundColor: '#ffffff',
    fontFamily: 'Helvetica',
    fontSize: 10
  },
  header: {
    textAlign: 'center',
    fontSize: 22,
    marginBottom: 10,
    fontWeight: 'bold',
    color: '#2d2d2d',
    borderBottomWidth: 1,
    borderBottomColor: '#dddddd',
    paddingBottom: 10
  },
  subHeader: {
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 20,
    color: '#5e5e5e'
  },
  info: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    fontSize: 12,
    color: '#333'
  },
  infoDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2
  },
  infoItem: {
    fontWeight: 'bold'
  },
  infoValue: {
    fontWeight: 'normal',
    fontSize: 12
  },
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#dddddd',
    marginBottom: 20,
    borderRadius: 4,
    overflow: 'hidden'
  },
  tableRowHeader: {
    flexDirection: 'row',
    backgroundColor: '#f4f4f4',
    borderBottomWidth: 1,
    borderBottomColor: '#dddddd',
    padding: 6
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#dddddd',
    padding: 6
  },
  tableCell: {
    flex: 1,
    textAlign: 'center',
    fontSize: 10,
    padding: 6,
    borderRightWidth: 1,
    borderRightColor: '#dddddd',
    fontWeight: 'normal'
  },
  tableCellRightAlign: {
    flex: 1,
    textAlign: 'right',
    fontSize: 10,
    padding: 6,
    borderRightWidth: 1,
    borderRightColor: '#dddddd',
    fontWeight: 'normal'
  },
  tableCellTotal: {
    flex: 1,
    textAlign: 'center',
    fontSize: 10,
    padding: 6,
    fontWeight: 'bold'
  },
  totalSection: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#2d2d2d',
    paddingTop: 10,
    paddingBottom: 10,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  totalSectionDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2
  },
  totalSectionItem: {
    fontWeight: 'bold'
  },
  totalSectionValue: {
    fontWeight: 'normal',
    fontSize: 12
  },
  footer: {
    fontSize: 10,
    color: '#777',
    textAlign: 'center',
    marginTop: 20
  }
});

const ManualOrderPDF = ({ data }) => {
  console.log('data.product_details', data.product_details);
  return (
    <Document>
      <Page style={styles.page}>
        {/* Header */}
        <Text style={styles.header}>Manual Order</Text>
        <Text style={styles.subHeader}>Order Summary Report</Text>

        {/* Order Details */}
        <View style={styles.info}>
          <View style={styles.infoDetails}>
            <Text style={styles.infoItem}>Username:</Text>
            <Text style={styles.infoValue}>{data.username}</Text>
          </View>
          <View style={styles.infoDetails}>
            <Text style={styles.infoItem}>Area:</Text>
            <Text style={styles.infoValue}>{data.area}</Text>
          </View>
          <View style={styles.infoDetails}>
            <Text style={styles.infoItem}>Beat:</Text>
            <Text style={styles.infoValue}>{data.beat}</Text>
          </View>
          <View style={styles.infoDetails}>
            <Text style={styles.infoItem}>Outlet:</Text>
            <Text style={styles.infoValue}>{data.outlet}</Text>
          </View>
        </View>

        {/* Product Table */}
        <View style={styles.table}>
          <View style={styles.tableRowHeader}>
            <Text style={styles.tableCell}>Product Name</Text>
            <Text style={styles.tableCell}>UOM</Text>
            <Text style={styles.tableCell}>Rate</Text>
            <Text style={styles.tableCell}>Quantity</Text>
            <Text style={styles.tableCell}>Total Amount</Text>
          </View>

          {data.product_details.map((product, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.tableCell}>{product.product_name}</Text>
              <Text style={styles.tableCell}>{product.uom}</Text>
              <Text style={styles.tableCellRightAlign}>{Number(product.rate).toFixed(2)}</Text>
              <Text style={styles.tableCellRightAlign}>{product.quantity}</Text>
              <Text style={styles.tableCellRightAlign}>
                {Number(product.total_amount).toFixed(2)}
              </Text>
            </View>
          ))}
        </View>

        {/* Total Section */}
        <View style={styles.totalSection}>
          <View style={styles.totalSectionDetails}>
            <Text style={styles.totalSectionItem}>Total Quantity: </Text>
            <Text style={styles.totalSectionValue}>{data.total_quantity}</Text>
          </View>
          <View style={styles.totalSectionDetails}>
            <Text style={styles.totalSectionItem}>Total Amount: </Text>
            <Text style={styles.totalSectionValue}>{Number(data.total_amount).toFixed(2)}</Text>
          </View>
        </View>

        {/* Footer */}
        <Text style={styles.footer}>
          Thank you for your order. If you have any questions, feel free to contact us.
        </Text>
      </Page>
    </Document>
  );
};

ManualOrderPDF.propTypes = {
  data: PropTypes.object
};

export default ManualOrderPDF;
